import PageBackTitle from "../Component/PageBackTitle";
import React, { useState, useEffect, useRef } from "react";
import "./UserForm.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import "../Responsive/FormResponsive.css";
import API_URL from "../../src/Config";
import { FiUpload } from "react-icons/fi";
import Select from "react-select";
import { MdAttachFile } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { IoCloseOutline } from "react-icons/io5";
import useClickOutside from "../useClickOutside";
import { useContext } from "react";
import DatePicker from "react-datepicker";
import { ThemeContext } from "../../src/ThemeContext";

function BreakDownForm({ isSidebarExpanded }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPermitPopupOpen, setIsPermitPopupOpen] = useState(false);
  const fileInputRef = useRef(null);
  const containerRef = useRef(null);
  const buttonRef = useRef(null);
  const popupRef = useRef(null)
  const permitFileInputRef = useRef(null);
  const [attachmentFile, setAttachmentFile] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [departmentMenuIsOpen, setDepartmentMenuIsOpen] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [permitAttachmentFile, setPermitAttachmentFile] = useState([]);
  const [permitSelectedFiles, setPermitSelectedFiles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [permitNo, setPermitNo] = useState("");
  const [breakdowntData, setBreakdowntData] = useState({
    department_name: "",
    problem_desc: "",
    tag_no: "",
    date: "",
  });
  const { theme } = useContext(ThemeContext);

  const handleDeleteFile = (indexToDelete) => {
    console.log("Before delete:", selectedFiles); // Debugging

    // Filter out the file at the given index and assign to updatedFiles
    const updatedFiles = selectedFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state with filtered files
    setSelectedFiles(updatedFiles);

    console.log("After delete:", updatedFiles); // Debugging

    // Close the popup if no files are left
    if (updatedFiles.length === 0) {
      handleCloseAttachment(); // Close the popup if no files remain
    }
  };

  const handleDeletePermitAttach = (indexToDelete) => {
    console.log("Before delete:", permitSelectedFiles); // Debugging

    // Filter out the file at the given index
    const updatedFiles = permitSelectedFiles.filter(
      (_, index) => index !== indexToDelete
    );

    // Update the state
    setPermitSelectedFiles(updatedFiles);

    // Close the popup if no files are left
    if (updatedFiles.length === 0) {
      handleClosePermitAttachment();
    }

    console.log("After delete:", updatedFiles); // Debugging
  };

  const handleUploadButtonClick = (isPermit = false) => {
    if (isPermit) {
      permitFileInputRef.current.click();
    } else {
      fileInputRef.current.click();
    }
  };
  const handleCloseAttachment = () => {
    setIsPopupOpen((prev) => !prev);
  };
  const handleClosePermitAttachment = () => {
    setIsPermitPopupOpen(false);
  };

  const handleFileInputChange = (e, isPermit = false) => {
    const files = Array.from(e.target.files);
    const newFileDetails = files.map((file) => ({
      name: file.name,
      size: file.size,
    }));

    if (isPermit) {
      setPermitSelectedFiles((prev) => [...prev, ...newFileDetails]);
      setPermitAttachmentFile((prevFiles) => [...prevFiles, ...files]);
    } else {
      setSelectedFiles((prev) => [...prev, ...newFileDetails]);
      setAttachmentFile((prevFiles) => [...prevFiles, ...files]);
    }

    setErrors((prevState) => ({
      ...prevState,
      attachment: "", // clear error if file selected
    }));
  };

  const handleIconClick = () => {
    setIsPopupOpen((prev) => !prev); // Toggle main popup
    if (isPermitPopupOpen) setIsPermitPopupOpen(false); // Close permit popup if it's open
  };
  const handlePermitIconClick = () => {
    setIsPermitPopupOpen((prev) => !prev); // Toggle permit popup
    setIsPopupOpen(false); // Close main popup if opened
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBreakdowntData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevState) => ({
      ...prevState,
      [name]: "",
    }));
  };

  const handleDepartmentChange = (selectedOption) => {
    setSelectedDepartment(selectedOption);
    setBreakdowntData((prevUserData) => ({
      ...prevUserData,
      department_id: selectedOption ? selectedOption.value : "",
      department_name: selectedOption ? selectedOption.label : "",
    }));
    setErrors((prevState) => ({
      ...prevState,
      department_name: "",
    }));
  };
  const handleDepartmentMenuOpen = () => {
    setDepartmentMenuIsOpen(true);
  };

  const fetchDepartment = async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const apiUrl = `${API_URL}/api/get_departments`;
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: authKey,
        },
      });
      if (response.ok) {
        const data = await response.json();
        const options = data.map((department) => ({
          label: department.DepartmentName,
          value: department.ID,
        }));
        setDepartments(options);
      } else {
        console.error("Failed to fetch departments");
      }
    } catch (error) {
      console.error("An error occurred while fetching departments:", error);
    }
  };

  useEffect(() => {
    fetchDepartment();
  }, []);
 
  
  const handleClosePopup = () => {
    // setIsSortPopup(false);
    // setIsPopupOpen(false);
    setIsPermitPopupOpen(false)
    setIsPopupOpen(false)
  };

  // useClickOutside([containerRef, buttonRef], () => setIsSortPopup(false));
  useClickOutside([containerRef, buttonRef], handleClosePopup, 200); // 200ms delay
  useClickOutside([popupRef, buttonRef], handleClosePopup, 300);


  const handleCancelClick = () => {
    navigate("/breakdown-schedules");
  };


  const handleSaveClick = async () => {
    const validationErrors = {};
    let hasError = false;
  
    // Validate fields
    if (!breakdowntData.department_name) {
      validationErrors.department_name = "Department is required";
      hasError = true;
    }
    if (!selectedOption) {
      validationErrors.tag_no = "Tag Selection is required";
      hasError = true;
    }
    if (!breakdowntData.problem_desc) {
      validationErrors.problem_desc = "Problem Description is required";
      hasError = true;
    }
    if (!permitNo) {
      validationErrors.permitNo = "Permit No is required";
      hasError = true;
    }
    if (!selectedDate) {
      validationErrors.date = "Date is required";
    }
    if (attachmentFile.length === 0) {
      validationErrors.attachment = "Breakdown Attachment is required";
      hasError = true;
    }
    if (permitAttachmentFile.length === 0) {
      validationErrors.permit_attachment = "Permit Attachment is required";
      hasError = true;
    }
  
    if (hasError) {
      setErrors(validationErrors);
      setSeverity("warning");
      showSnackbar("Please correct the errors before saving");
      return;
    }
  
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const formData = new FormData();
  
  
      const formattedDate = selectedDate.toLocaleDateString('en-CA'); // 'en-CA' format is YYYY-MM-DD
      formData.append("date", formattedDate);
      
      formData.append("department_name", breakdowntData.department_name);
      formData.append("department_id", breakdowntData.department_id);
      formData.append("equipment_id", selectedOption ? selectedOption.value : "");
      formData.append("tag_no", selectedOption ? selectedOption.label : "");
      formData.append("problem_desc", breakdowntData.problem_desc);
      formData.append("permit_no", permitNo);
  
      attachmentFile.forEach((file) => {
        formData.append("attachments", file);
      });
      permitAttachmentFile.forEach((file) => {
        formData.append("permit_attachments", file);
      });
  
      const response = await axios.post(
        `${API_URL}/api/add_breakdown_schedule`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.status === 200) {
        setSeverity("success");
        showSnackbar("Breakdown added successfully");
        setTimeout(() => {
          navigate("/breakdown-schedules");
        }, 1000);
      }
    } catch (error) {
      console.error("Error saving Breakdown:", error.message);
      setSeverity("error");
      showSnackbar("Error occurred while saving breakdown");
    } finally {
      setIsLoading(false);
    }
  };
  

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.get(`${API_URL}/api/get_equipment`, {
          headers: {
            Authorization: authKey,
          },
        });
        // Assuming response.data is an array of equipment objects
        const optionsData = response.data.Items.map((item) => ({
          value: item.ID,
          label: item.TagNo,
        }));
        setOptions(optionsData);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setErrors((prevState) => ({
      ...prevState,
      tag_no: "",
    }));
  };

  const handlePermitNoChange = (e) => {
    setPermitNo(e.target.value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setBreakdowntData((prevState) => ({
      ...prevState,
      date: date,
    }));

    // Clear schedule start date error when it changes
    setErrors((prevErrors) => ({
      ...prevErrors,
      date: null,
    }));
  };

  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content" ref={containerRef}>
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New BreakDown Schedules</PageBackTitle>
              <div className="data-form-heading-content-right-side"></div>
            </div>
          </div>
          <div className="header-separator"></div>
          <div className="data-form-body">
            <form className="form-detail">
              <div className="new-data-form">
                <div className="form-group-select">
                  <label htmlFor="department_name">
                    Department<span className="text-danger">*</span>
                  </label>
                  {/* <div className="d-flex-col"> */}
                  <Select
                    id="department_name"
                    // className="w-100"
                    options={departments}
                    value={selectedDepartment}
                    onChange={handleDepartmentChange}
                    // components={{ Control: CustomControl, Menu: CustomMenu }}
                    placeholder="Select Department"
                    isSearchable
                    menuIsOpen={departmentMenuIsOpen}
                    onMenuOpen={handleDepartmentMenuOpen}
                    onMenuClose={() => setDepartmentMenuIsOpen(false)}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                         border: `1px solid ${theme === "dark" ? "#444" : "#ccc"}`,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />

                  {/* </div> */}
                  {errors.tag_no && (
                    <div className="error-message">
                      {errors.department_name}
                    </div>
                  )}
                </div>


                <div className="form-group-select">
                  <label htmlFor="tag_no">
                    Tag Selection<span className="text-danger">*</span>
                  </label>

                  <Select
                    value={selectedOption}
                    onChange={handleChange}
                    options={options}
                    placeholder="Select a tag"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
                        color: theme === "dark" ? "#fff" : "#333", // Text color
                        borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
                        cursor: "pointer",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
                        },
                      }),
                      menu: (provided) => ({
                        ...provided,
                        border: `1px solid ${theme === "dark" ? "#444" : "#ccc"}`,
                        backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.isFocused
                          ? "#666" // Gray when hovered
                          : theme === "dark"
                          ? "#000"
                          : "#fff", // Black background for options in dark mode
                        color: state.isFocused
                          ? "#fff"
                          : theme === "dark"
                          ? "#fff"
                          : "#333", // Text color
                        cursor: "pointer",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: theme === "dark" ? "#fff" : "#333", // Selected option text color
                      }),
                    }}
                  />

                  {errors.tag_no && (
                    <div className="error-message">{errors.tag_no}</div>
                  )}
                </div>


                <div className="form-group">
                  <label htmlFor="date">
                    Date<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <DatePicker
                      selected={selectedDate}
                      onChange={handleDateChange}
                      name="date"
                      id="date"
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Select date"
                      className="form-control"
                      isClearable
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                    />
                  </div>
                  {errors.date && (
                    <div className="error-message">{errors.date}</div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="permitNo">
                    Permit No <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      id="permitNo"
                      className="form-control"
                      value={permitNo}
                      onChange={handlePermitNoChange}
                      placeholder="Enter permit no"
                    />
                  </div>
                  {errors.permitNo && (
                    <div className="error-message">{errors.permitNo}</div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="PermitAttachment">
                    Permit Attachment <span className="text-danger">*</span>
                  </label>
                  <button
                    type="button"
                    className="challan-btn"
                    onClick={() => handleUploadButtonClick(true)}
                  >
                    <FiUpload /> Upload File
                  </button>
                  <input
                    id="PermitAttachment"
                    type="file"
                    ref={permitFileInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileInputChange(e, true)}
                    multiple
                  />
                  {permitSelectedFiles.length > 0 && (
                    <span
                      className="inquiry-file-btn"
                      onClick={handlePermitIconClick}
                      ref={buttonRef}
                    >
                      <MdAttachFile className="inquiry-file-icon" />{" "}
                      {`${permitSelectedFiles.length}`}
                    </span>
                  )}

                  {isPermitPopupOpen && (
                    <div
                      className="attach-popup-amcs breakdown-first-popup"
                      ref={popupRef}
                    >
                      <div className="attach-popup-contant">
                        <div className="attachment-header">
                          <div className="attachment-header-content">
                            Attachments
                          </div>
                          <button
                            className="fiile-close-btn"
                            onClick={handleClosePermitAttachment}
                          >
                            <IoCloseOutline className="file-close-icon" />
                          </button>
                        </div>

                        {/* Render attachments if there are files */}
                        {permitSelectedFiles.length > 0 && (
                          <div className="attach-scrroll-body">
                            {permitSelectedFiles.map((file, index) => (
                              <div
                                className="attach-popup-contant-body"
                                key={index}
                              >
                                <div className="attach-file-container">
                                  <div className="attach-file-show">
                                    <div className="text-attachment">
                                      {file.name}
                                    </div>
                                    <div className="text-attachment-file">
                                      File Size: {(file.size / 1024).toFixed(2)}{" "}
                                      KB
                                    </div>
                                  </div>

                                  {/* Delete button for each file */}
                                  <div
                                    className="file-delete-btn"
                                    onClick={() =>
                                      handleDeletePermitAttach(index)
                                    }
                                  >
                                    <span>
                                      <MdDeleteOutline className="file-delete-icon" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="problem_desc">
                    Problem Description<span className="text-danger">*</span>
                  </label>
                  {/* <div className="d-flex-col"> */}
                  <div className="input-group">
                    <textarea
                      name="problem_desc"
                      rows={4}
                      value={breakdowntData.problem_desc}
                      onChange={handleInputChange}
                      placeholder="Description"
                    />
                  </div>
                  {errors.problem_desc && (
                    <div className="error-message">{errors.problem_desc}</div>
                  )}
                  {/* </div> */}
                </div>
                <div className="form-group">
                  <label htmlFor="Attachment">
                    Breakdown Attachment <span className="text-danger">*</span>
                  </label>

                  <button
                    type="button"
                    className="challan-btn"
                    onClick={() => handleUploadButtonClick(false)}
                  >
                    <FiUpload /> Upload File
                  </button>
                  <input
                    className="w-100"
                    id="Attachment"
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileInputChange(e, false)}
                    multiple
                  />

                  {selectedFiles.length > 0 && (
                    <span
                      className="inquiry-file-btn"
                      onClick={handleIconClick}
                      ref={buttonRef}
                    >
                      <MdAttachFile className="inquiry-file-icon" />{" "}
                      {`${selectedFiles.length}`}
                    </span>
                  )}

                  {isPopupOpen && (
                    <div
                      className="attach-popup-amcss breakdown-second-popup"
                      ref={popupRef}
                    >
                      <div className="attach-popup-contant">
                        <div className="attachment-header">
                          <div className="attachment-header-content">
                            Attachments
                          </div>
                          <button
                            className="fiile-close-btn"
                            onClick={handleCloseAttachment}
                          >
                            <IoCloseOutline className="file-close-icon" />
                          </button>
                        </div>
                        {selectedFiles.length > 0 && (
                          <div className="attach-scrroll-body">
                            {selectedFiles.map((file, index) => (
                              <div
                                className="attach-popup-contant-body"
                                key={index}
                              >
                                <div className="attach-file-container">
                                  <div className="attach-file-show">
                                    <div className="text-attachment">
                                      {file.name}
                                    </div>
                                    <div className="text-attachment-file">
                                      File Size:(
                                      {(file.size / 1024).toFixed(2)} KB)
                                    </div>
                                  </div>
                                  <div
                                    className="file-delete-btn"
                                    onClick={() => handleDeleteFile(index)}
                                  >
                                    <span>
                                      <MdDeleteOutline className="file-delete-icon" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {errors.attachment && (
                    <div className="error-message">{errors.attachment}</div>
                  )}
                </div>
              </div>
            </form>
          </div>
          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                type="button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default BreakDownForm;
